import { createStore as reduxCreateStore } from "redux";

const reducer = (state, action) => {
    switch (action.type) {
        case "INCREMENT":
            return {
                ...state,
                count: state.count + 1
            }

        case "UPDATE_USER":
            return {
                ...state,
                user: action.payload
            }

        case "UPDATE_SECTION":
            return {
                ...state,
                section: action.payload
            };

        case "NEW_POST":
            return {
                ...state,
                refreshData: action.value
            };

        case "UPDATE_EVENTS":
            return {
                ...state,
                events: action.payload
            };

        case "UPDATE_LEADERBOARD":
            return {
                ...state,
                leaderboard: action.payload
            }

        case "UPDATE_POINTS":
            return {
                ...state,
                points: action.value
            }

        case "UPDATE_AVLPOINTS":
            return {
                ...state,
                totalPoints: action.value
            }

        case "ADD_CART":
            return {
                ...state,
                cartItems: action.payload
            }

        case "UPDATE_EMPLOYEES":
            return {
                ...state,
                employees: action.payload
            }
    }

    return state;
};

const initialState = {
    count: 0,
    user: undefined,
    section: 'HOME',
    refreshData: "NO",
    events: {
        bdays: [],
        adays: []
    },
    leaderboard: [],
    points: -1,
    totalPoints: 0,
    cartItems: []
};

const createStore = () => reduxCreateStore(reducer, initialState);

export default createStore;
